import { environment } from '~/environments';
import localesJson from './locales.json';

export const defaultLocale = localesJson.defaultLocale;
export const locales = localesJson.locales;
export const localePrefix = 'always';
export const localeCookieConfigs = {
  domain: environment.appEnv === 'local' ? 'localhost' : '.grimme.com',
};
